import { apiFetch, getApiUrl } from "../auth/apiClient";
import { startIciciPayment } from "../properties/api";

// Reuse the properties form-submit helper (navigates the browser to ICICI).
export { startIciciPayment };

export const paymentsApi = {
  // ---- resident ----
  listMyInvoices: (status) =>
    apiFetch(
      `/api/maintenance/me/invoices${status ? `?status=${status}` : ""}`,
      { authRequired: true }
    ),
  pay: (id, channel = "web") =>
    apiFetch(`/api/maintenance/invoices/${id}/pay`, {
      method: "POST",
      authRequired: true,
      body: { channel },
    }),

  // ---- UPI direct ----
  payUpi: (invoiceId) =>
    apiFetch(`/api/maintenance/invoices/${invoiceId}/pay-upi`, {
      method: "POST",
      authRequired: true,
    }),
  submitUtr: (paymentId, utr) =>
    apiFetch(`/api/maintenance/payments/${paymentId}/submit-utr`, {
      method: "POST",
      authRequired: true,
      body: { utr },
    }),
  verifyUtr: (paymentId) =>
    apiFetch(`/api/maintenance/payments/${paymentId}/verify-utr`, {
      method: "POST",
      authRequired: true,
    }),
  upiPending: () =>
    apiFetch("/api/maintenance/admin/upi-pending", { authRequired: true }),

  // ---- admin ----
  createBatch: (body) =>
    apiFetch(`/api/maintenance/invoices/batch`, {
      method: "POST",
      authRequired: true,
      body,
    }),
  listInvoices: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.set(k, v);
    });
    const s = qs.toString();
    return apiFetch(`/api/maintenance/invoices${s ? `?${s}` : ""}`, {
      authRequired: true,
    });
  },
  adminSummary: () =>
    apiFetch(`/api/maintenance/admin/summary`, { authRequired: true }),
  cancel: (id) =>
    apiFetch(`/api/maintenance/invoices/${id}/cancel`, {
      method: "POST",
      authRequired: true,
    }),
  refund: (id) =>
    apiFetch(`/api/maintenance/payments/${id}/refund`, {
      method: "POST",
      authRequired: true,
    }),
  listVillas: () => apiFetch(`/api/villas`, { authRequired: true }),
};

// Receipt is access-controlled, so fetch it with the bearer token and
// trigger a blob download (an <a href> can't carry the Authorization header).
export async function downloadReceipt(invoiceId, filename) {
  const url = `${getApiUrl()}/api/maintenance/invoices/${invoiceId}/receipt.pdf`;
  const token = localStorage.getItem("access_token");
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error("Receipt is not available yet.");
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = filename || "receipt.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objUrl);
}
